// @flow

import React from 'react';
import { RichText } from 'components/Text';
import type { RichTextBlockData } from 'api/cms';

const RichTextBlock = ({
  blockIndex,
  data: { html },
  fullWidthLayout,
  isSidebar
}: {
  blockIndex: number,
  data: RichTextBlockData,
  fullWidthLayout?: boolean,
  isSidebar?: boolean
}) => (
  <RichText
    dangerouslySetInnerHTML={{ __html: html }}
    textAlign={fullWidthLayout && 'center'}
    small={isSidebar}
    analyticsData={{
      eventName: 'CMS Block',
      eventProperties: {
        block_position: blockIndex,
        block_type: 'Rich Text'
      }
    }}
  />
);

export default RichTextBlock;
